export default __webpack_public_path__ + "bc8c1bd4ece46eb16fccf7eaf74f52dd.png";